import { useState } from 'react';
import OrderSearch from './OrderSearch';
import OrderTable from './OrderTable';
import OrderCount from './OrderCount';

function Order() {
	const [Params, setParams] = useState({});
	const [CountParams, setCountParams] = useState({});
	return (
		<>
			<OrderCount getCountParams={(e) => setCountParams(e)} />
			<OrderSearch getParams={(e) => setParams(e)} countParams={CountParams} />
			<OrderTable params={Params} countParams={CountParams} />
		</>
	);
}

export default Order;
